import { LocationPage } from "./LocationPage";
import { Route, Routes } from "react-router-dom";
import { LocationProvider } from "./LocationContext";

type Props = {};
const CatalogLocation = (props: Props) => {
  return (
    <LocationProvider>
      <Routes>
        <Route index element={<LocationPage />}></Route>
        <Route path=":locationId" element={<LocationPage />}></Route>
      </Routes>
    </LocationProvider>
  );
};

export default CatalogLocation;
